export default {
    DictionaryApproveProjectTab: "DictionaryProjectApproveTab",

    DictionaryRegularApproveTab: "DictionaryRegularApproveTab",
    DictionaryApproveBudgetTab: "DictionaryApproveBudgetTab",
    DictionaryApproveFeeTab: "DictionaryApproveFeeTab",
    DictionaryRevenueOtherApproveTab: "DictionaryRevenueOtherApproveTab",
    DictionaryExpenseOtherApproveTab: 'DictionaryExpenseOtherApproveTab',
    DictionaryBusinessApproveTab: "DictionaryBusinessApproveTab",
    DictionaryApproveInvestTab: "DictionaryApproveInvestTab",
    DictionaryApproveCriteriaTab: "DictionaryApproveCriteriaTab"
}